var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "InstagramColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "22.3693112%",
    x2: "99.999575%",
    y2: "27.7870934%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-18.6%",
    y: "-23.4%",
    width: "137.3%",
    height: "146.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.5966687,2.48562477 C90.3340121,-0.828521248 99.6362486,-0.82855176 105.373592,2.48559426 L171.167223,40.4906273 C174.256129,42.2749046 175.682013,44.656026 175.444875,46.9913184 L175.470261,46.9913184 L175.470261,81.9848534 L175.444875,81.9848534 C175.241543,83.9871995 173.815659,85.9558605 171.167223,87.4857292 L105.373592,125.490762 C99.6362486,128.804908 90.3340121,128.804908 84.5966687,125.490762 L18.803038,87.4857292 C16.1546015,85.9558605 14.7287175,83.9871995 14.5253859,81.9848534 L14.5,81.9848534 L14.5,46.9913184 L14.5253859,46.9913184 C14.2882471,44.656026 15.7141312,42.2749046 18.803038,40.4906273 L84.5966687,2.48562477 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-6.6%",
    width: "110.6%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.8133343%",
    x2: "93.8547498%",
    y2: "50.7911127%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95,0 C98.8971583,0 102.63469,0.893817226 105.390392,2.48482235 L171.196169,40.4778077 C173.95187,42.0688128 175.5,44.2266786 175.5,46.4766998 C175.5,48.7267211 173.95187,50.8845866 171.196169,52.475592 L105.390384,90.4685756 C102.634682,92.059581 98.8971507,92.9534073 95,92.9534073 C91.1028493,92.9534073 87.3653174,92.0595884 84.6096158,90.4685833 L18.8038396,52.4755958 C16.048138,50.8845907 14.5,48.7267249 14.5,46.4767036 C14.5,44.2266824 16.0481388,42.0688168 18.8038405,40.4778115 L84.6096158,2.48482306 C87.3653176,0.893817703 91.102857,0 95,0 Z M94.9913422,15.0475026 C86.090245,15.0475029 79.8560154,17.7070135 75.4487599,20.0215863 C71.3272397,22.1511934 67.4048716,24.4157755 63.6123805,26.6053715 L60.5818505,28.3550483 C56.7547249,30.5646406 52.8410158,32.8142256 49.178405,35.1887873 C45.1954237,37.7183204 40.5543792,41.3376533 40.5630377,46.4817038 C40.5716963,51.6257543 45.1694442,55.2200898 49.1784011,57.76462 C52.3734446,59.8592332 55.8022725,61.8388649 59.144513,63.7685085 L65.2055691,67.267866 C68.5045165,69.1725143 71.8813952,71.1221503 75.4401021,72.926817 C79.8300402,75.2313915 86.0729276,77.9059011 94.9913422,77.9059008 C103.909757,77.9059005 110.126672,75.2463912 114.542586,72.9368173 C118.560202,70.8671993 122.387328,68.6576021 126.093233,66.5179969 L129.418157,64.5983532 C133.236624,62.3937602 137.158989,60.1391791 140.812941,57.7696163 C144.795923,55.2300848 149.419649,51.6207503 149.428308,46.4766998 C149.436967,41.3326493 144.821898,37.7383129 140.821599,35.1887835 C137.756435,33.1691565 134.45749,31.2645084 131.236471,29.4048518 L124.725169,25.6455477 C121.452197,23.7558967 118.092641,21.8162549 114.551252,20.0215863 C110.161314,17.7270102 103.892439,15.0475023 94.9913422,15.0475026 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.9%",
    y: "-1.6%",
    width: "101.9%",
    height: "103.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95,19.2917197 C101.355453,19.2917195 105.961858,21.2513563 109.659104,23.185999 C112.880123,24.8056999 115.910659,26.5553798 119.529977,28.6449938 L126.067259,32.4192945 C129.080471,34.1589732 132.310144,36.0536223 135.383966,38.0382558 C138.700231,40.1528652 142.077111,42.8023782 142.08577,46.4766998 C142.094428,50.1510215 138.691578,52.8055322 135.33202,54.9451371 C131.799288,57.2247166 127.954837,59.4443075 124.231615,61.5939108 L120.880717,63.5285511 C117.252741,65.6231645 113.520863,67.787765 109.667762,69.7624005 L109.607157,69.7973977 C105.953205,71.7070452 101.32082,73.6516835 94.9826845,73.6616819 C88.6445489,73.6716803 84.0468011,71.7070414 80.3322382,69.7624005 C76.8168246,67.972731 73.3533673,65.9731003 70.3921073,64.263416 L64.3310473,60.764066 C61.1706382,58.939403 57.9322983,57.0297534 54.6160335,54.9151439 C51.2997687,52.8005344 47.9228926,50.1510253 47.9142342,46.4767036 C47.9055757,42.802382 51.3084303,40.1478725 54.65933,38.0132665 C58.2007197,35.7286881 62.0451629,33.509096 65.7683848,31.3594927 L68.8162303,29.5998193 C72.4874999,27.4802106 76.375235,25.2356231 80.3841924,23.161006 C84.0468037,21.2463592 88.6445474,19.2917199 95,19.2917197 Z M104.626449,35.2445708 C100.248419,34.0990825 95.3286193,33.8408566 90.664581,34.5117578 C86.0005427,35.182659 81.8656788,36.743358 78.9302678,38.9408524 C75.9948569,41.1383469 74.4309757,43.8438207 74.4921457,46.6186986 C74.5533157,49.3935765 76.2359516,52.0751926 79.2672799,54.2288426 C82.2986082,56.3824926 86.500931,57.881929 91.1930326,58.4840801 C95.8851343,59.0862313 100.791956,58.7557964 105.118073,57.546349 C109.44419,56.3369015 112.936012,54.3193381 115.027474,51.8207141 C116.772895,52.4858069 118.799179,52.8637921 120.888666,52.9140639 C122.978153,52.9643357 125.051879,52.6849952 126.887092,52.1060504 C128.722306,51.5271056 130.249649,50.6704334 131.305061,49.6280572 C132.360473,48.5856811 132.904071,47.3969893 132.877456,46.189674 C132.850842,44.9823587 132.255024,43.80204 131.154004,42.7755096 C130.052985,41.7489791 128.488368,40.91503 126.628229,40.3632391 C124.76809,39.8114483 122.682719,39.5626682 120.596125,39.6436264 C118.509531,39.7245846 116.500571,40.1322209 114.785034,40.8227452 C112.584107,38.355662 109.004479,36.3900591 104.626449,35.2445708 Z M90.4797855,39.0076049 C93.0350281,38.3965279 95.8467472,38.2366434 98.5593782,38.5481675 C101.272009,38.8596917 103.763719,39.6286357 105.719417,40.7577586 C108.335942,42.2736966 109.805119,44.326578 109.805119,46.4667034 C109.805119,48.6068287 108.335942,50.65971 105.719417,52.1756481 C103.763719,53.3047711 101.272009,54.073711 98.5593782,54.3852354 C95.8467472,54.6967597 93.0350281,54.5368786 90.4797855,53.9258018 C87.9245428,53.314725 85.7405415,52.2799035 84.2039595,50.9521955 C82.6673775,49.6244875 81.8472323,48.0635242 81.8472324,46.4667034 C81.8472325,44.8698825 82.6673773,43.3089194 84.2039595,41.9812112 C85.7405418,40.6535031 87.9245428,39.6186819 90.4797855,39.0076049 Z M119.750197,44.0274299 C120.514364,43.8458183 121.354691,43.7992023 122.164774,43.8934824 C122.974857,43.9877625 123.718271,44.2187008 124.300893,44.5570562 C125.080178,45.0096233 125.516868,45.6221175 125.515245,46.2602748 C125.513622,46.8984321 125.073819,47.5101823 124.292235,47.9614262 C123.707895,48.2987923 122.963304,48.5284667 122.152745,48.6213729 C121.342186,48.7142791 120.50211,48.6662395 119.738869,48.483333 C118.975628,48.3004266 118.323545,47.9908773 117.865192,47.5938832 C117.406838,47.1968891 117.162829,46.7303052 117.164043,46.253196 C117.165256,45.7760869 117.41164,45.3099103 117.872011,44.913695 C118.332382,44.5174797 118.986029,44.2090414 119.750197,44.0274299 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.6%",
    y: "-2.8%",
    width: "103.2%",
    height: "105.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "InstagramColor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5966687,12.4856248 C90.3340121,9.17147875 99.6362486,9.17144824 105.373592,12.4855943 L171.167223,50.4906273 C174.256129,52.2749046 175.682013,54.656026 175.444875,56.9913184 L175.470261,56.9913184 L175.470261,91.9848534 L175.444875,91.9848534 C175.241543,93.9871995 173.815659,95.9558605 171.167223,97.4857292 L105.373592,135.490762 C99.6362486,138.804908 90.3340121,138.804908 84.5966687,135.490762 L18.803038,97.4857292 C16.1546015,95.9558605 14.7287175,93.9871995 14.5253859,91.9848534 L14.5,91.9848534 L14.5,56.9913184 L14.5253859,56.9913184 C14.2882471,54.656026 15.7141312,52.2749046 18.803038,50.4906273 L84.5966687,12.4856248 Z",
    id: "Glow",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    opacity: 0.699999988,
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.8064702,2.37870131 C90.1518653,-0.792900278 98.8184716,-0.792900516 104.163867,2.37870083 L165.462263,38.7490884 C170.807659,41.9206907 170.807659,47.062872 165.462263,50.2344741 L104.16386,86.6048628 C98.8184696,89.776462 90.1518669,89.7764728 84.8064702,86.6048705 L23.5080703,50.2344779 C18.1626748,47.0628763 18.162674,41.9206912 23.5080707,38.7490884 L84.8064702,2.37870131 Z",
    id: "Subtract",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-14",
    fillOpacity: 0.230000004,
    fill: "#000000",
    fillRule: "nonzero",
    points: "47.9316406 46.2414901 94.9854507 24.6204834 142.039261 46.2414901 142.039261 64.5506086 94.9854507 85.9841499 47.9316406 64.5506086"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-9)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramColor);
export default __webpack_public_path__ + "static/media/InstagramColor.bb20364e3882ff781f0bba5a40538f71.svg";
export { ForwardRef as ReactComponent };